import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { LoginLayout } from '@skunexus/component-catalog';
import useOkta from './useOkta';

const OktaContext = createContext();

function OktaContextProvider({ app, children }) {
    const contextValue = useOkta({ app });

    const [{ isLoading }] = contextValue;
    return (
        <OktaContext.Provider value={contextValue}>
            {isLoading ? <LoginLayout landingMode /> : children}
        </OktaContext.Provider>
    );
}

OktaContextProvider.propTypes = {
    children: PropTypes.any,
};

OktaContextProvider.defaultProps = {
    children: null,
};

export default OktaContextProvider;
export const useOktaContext = () => useContext(OktaContext);
